import './Stack.css';
import React from 'react';
import classnames from 'classnames';
import GlobalProps from '../globalProps';

export type SpacingSizes =
  | 'zero'
  | 'xxxs'
  | 'xxs'
  | 'xs'
  | '16'
  | 'sm'
  | 'default'
  | 'lg'
  | 'xl'
  | 'xxl'
  | 'xxxl'
  | 'md';

interface Props extends GlobalProps {
  size?: SpacingSizes;
  withSeparator?: boolean;
  line?: boolean;
  justify?: 'left' | 'center' | 'right' | 'space-between';
  wrap?: boolean;
  align?: 'start' | 'center' | 'end';
  fullWidth?: boolean;
}

export function Stack({
  className,
  style,
  children,
  size,
  withSeparator,
  line,
  justify,
  wrap,
  align,
  fullWidth,
}: Props): JSX.Element {
  return (
    <div
      className={classnames(
        'stack',
        {
          'stack--with-separator': withSeparator,
          'stack--line': line,
          'stack--wrap': wrap,
          'stack--full-width': fullWidth,
        },
        size && `stack--${size}`,
        justify && `stack--justify-${justify}`,
        align && `stack--align-${align}`,
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
}
